export interface LoggableContext {
    name: string;
    debug?: boolean;
}
export abstract class Loggable<
    ContextType extends LoggableContext = LoggableContext
> {
    protected abstract className: string;
    private get logKey() {
        return `${this.className}{${this.context.name}}`;
    }
    constructor(public context: ContextType) {}
    protected debug(...messages: Array<any>) {
        if (this.context.debug) {
            console.debug(this.logKey, ...messages);
        }
    }
    protected debugSuccess(...messages: Array<any>) {
        if (this.context.debug) {
            console.debug(
                [this.logKey, ' %c', this.joinMessages(messages)].join(''),
                'color: lightgreen'
            );
        }
    }
    protected debugInfo(...messages: Array<any>) {
        if (this.context.debug) {
            console.debug(
                [this.logKey, ' %c', this.joinMessages(messages)].join(''),
                'color: cyan'
            );
        }
    }
    protected warn(...messages: Array<any>) {
        console.warn(this.logKey, ...messages);
    }
    private joinMessages(messages: Array<any>, separator: string = ' ') {
        return messages
            .map(message => {
                if (typeof message === 'object') {
                    return JSON.stringify(message);
                }
                return message;
            })
            .join(separator);
    }
}



// WEBPACK FOOTER //
// ./src/utils/Loggable.ts